export const moduleName = 'template_details'
